import ProgramThumbnail from'./ProgramThumbnail';export default ProgramThumbnail;